import { createSelector } from "reselect";

const getErrors = state => state.get("errorReducer");

export const selectErrors = createSelector([getErrors], errors => {
  return errors.get("errors").toArray();
});
